import React from 'react';
import { Box, Grid } from '@mui/material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import dayjs from 'dayjs';

// Import the styled components from your new file
import {
  Container,
  SectionTitle,
  FieldLabel,
  FieldValue,
  EditButton,
} from './styles';
import { useNavigate } from 'react-router-dom';

// A small helper component to keep the JSX clean
interface DetailItemProps {
  label: string;
  value: string;
}

const DetailItem: React.FC<DetailItemProps> = ({ label, value }) => (
  <Box>
    <FieldLabel>{label}</FieldLabel>
    <FieldValue>{value}</FieldValue>
  </Box>
);

interface ShiftDetailsProps {
  date: string;
  position: string;
  startTime: string;
  endTime: string;
  numberOfWorkers: string;
  experience: number | string;
  appointedMember: string;
  clockInTime?: string;
  clockOutTime?: string;
  shift_id?: number;
  status: string;
  shiftEndDateTime?: string;
  isSleepover?: boolean;
  label?: string;
}

const ShiftDetails: React.FC<ShiftDetailsProps> = ({
  date,
  position,
  startTime,
  endTime,
  numberOfWorkers,
  experience,
  appointedMember,
  clockInTime,
  clockOutTime,
  shift_id,
  status,
  shiftEndDateTime,
  isSleepover,
  label
}) => {

  const navigate = useNavigate();

  const getTotalHours = (start: string, end: string): string => {
    const startDate = new Date(`1970-01-01T${start}:00`);
    const endDate = new Date(`1970-01-01T${end}:00`);
    const diffMs = endDate.getTime() - startDate.getTime();
    const diffHrs = diffMs / (1000 * 60 * 60);
    return diffHrs.toFixed(2);
  }

  const handleEdit = () => {
    navigate(`/facility/shift/update/${shift_id}`);
  };

  const isEditable = !['completed', 'cancelled'].includes(status) &&
    (!shiftEndDateTime || dayjs(shiftEndDateTime).isAfter(dayjs()));

  return (
    <Container>
      {/* Header Section */}
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <SectionTitle>Shift Details</SectionTitle>
        {isEditable && (
          <EditButton startIcon={<EditOutlinedIcon fontSize="small" />} onClick={handleEdit}>
            Edit
          </EditButton>
        )}
      </Box>

      {/* Grid Layout */}
      <Grid container spacing={3}>

        {/* Row 1 */}
        <Grid size={{ xs: 12, md: 6 }}>
          <DetailItem label="Scheduled Time" value={`${startTime} - ${endTime}`} />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <DetailItem label="Total Hours" value={getTotalHours(startTime, endTime)} />
        </Grid>

        {/* Row 3 */}
        <Grid size={{ xs: 12, md: 6 }}>
          <DetailItem label="Experience" value={`${experience}+ years`} />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <DetailItem label="Workers Required" value={numberOfWorkers} />
        </Grid>

        {/* Full Width Row */}
        <Grid size={12}>
          <DetailItem
            label="Appoint Member"
            value={appointedMember}
          />
        </Grid>

        {label && (
          <Grid size={12}>
            <DetailItem label="Label" value={label} />
          </Grid>
        )}

        {isSleepover && (
          <Grid size={12}>
            <DetailItem label="Sleepover Shift" value="Yes" />
          </Grid>
        )}

      </Grid>
    </Container>
  );
};

export default ShiftDetails;